import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Youtube, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import { current_year, support_mail, support_number } from "../../utils/constant";

const socialLinks = [
    { icon: Facebook, url: "https://www.facebook.com/iris.analysis1", label: "Facebook" },
    { icon: Instagram, url: "https://www.instagram.com/iris.analysis/", label: "Instagram" },
    { icon: Youtube, url: "https://www.youtube.com/@irisanalysis", label: "YouTube" },
    { icon: Linkedin, url: "https://www.linkedin.com/company/irisanalysis/", label: "LinkedIn" },
];

function Footer() {
    return (
        <footer className="bg-[#e6f4f3] text-[#0b3d2e]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-12">

                    <div className="space-y-6">
                        <a href="/" className="flex items-center gap-2">
                            <span className="text-xl font-bold text-[#004d46]">Iris Analysis 2.0</span>
                        </a>
                        <p className="text-[#4f6f6a] leading-relaxed text-justify">
                            Iris Analysis, powered by AI (Artificial Intelligence) and affiliated with American Research Institute of Dermis & Genetic Evaluation , is a scientific assessment of 100 Billion Neurons of a person's brain that reveals the Pre-natal Unique Abilities & Inherent talent of the person. Know your Best & beat the Rest !
                        </p>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-[#004d46]">Useful Links</h4>
                        <ul className="space-y-4">
                            {[
                                { name: "Home", href: "/" },
                                { name: "Business Video", href: "/#business-video" },
                                { name: "Types of Reports", href: "/#reports" },
                                { name: "Iris Analysis Benefit", href: "/#benefits" },
                                { name: "Business Opportunity", href: "/#business" },
                                { name: "Testimonials", href: "/#community" },
                                { name: "Iris Analysis Software Price", href: "/#business" },
                            ].map(link => (
                                <li key={link.name}>
                                    <a href={link.href} className="flex items-center gap-3 text-[#4f6f6a] hover:text-[#004d46] transition">
                                        <span className="w-2 h-2 rounded-full bg-[#8bcf6a]" /> {link.name}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-lg font-semibold mb-6 text-[#004d46]">Login & Policies</h4>
                        <ul className="space-y-4">
                            {[
                                { name: "Admin Login", href: "https://admin.irisanalysis.ai/auth/login" },
                                { name: "Partner Login", href: "https://admin.irisanalysis.ai/auth/login/partner" },
                                { name: "Affiliate Login", href: "https://admin.irisanalysis.ai/auth/login/partner" },
                                { name: "Privacy Policy", path: "/privacy-policy" },
                                { name: "Return/Refund Policy", path: "/refund-policy" },
                                { name: "Shipping Policy", path: "/shipping-policy" },
                                { name: "Terms and Conditions", path: "/terms-of-use" },
                            ].map(item => (
                                <li key={item.name}>
                                    {item.path ? (
                                        <Link to={item.path} className="flex items-center gap-3 text-[#4f6f6a] hover:text-[#004d46] transition">
                                            <span className="w-2 h-2 rounded-full bg-[#8bcf6a]" /> {item.name}
                                        </Link>
                                    ) : (
                                        <a href={item.href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-[#4f6f6a] hover:text-[#004d46] transition">
                                            <span className="w-2 h-2 rounded-full bg-[#8bcf6a]" /> {item.name}
                                        </a>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>



                </div>
            </div>

            <div className="border-t border-[#cfe7e4]">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <p className="text-center text-[#4f6f6a] text-sm">
                        Copyright Contents {current_year} - All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
